<template>
  <app-modal :modal-id="modalId" :title="modalTitle" :preloader="preloader"
                @submit="submit" @close-modal="closeModal" modal-size="extra-large">
        <template slot="header">
            <h5 class="modal-title" id="ModalLabel">{{ modalTitle }}</h5>
            <button type="button" class="close outline-none" @click.prevent="closeModal">
                <span>
                    <app-icon :name="'x'"></app-icon>
                </span>
            </button>
        </template>
        <template slot="body">
            <app-overlay-loader v-if="preloader" />
            <form class="mb-0" :class="{ 'loading-opacity': preloader }" ref="form"
                :data-url='selectedUrl ? `employees/${inputs.id}` : `employees`'>
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group mb-0">
                            <label class="col-sm-2 mb-sm-0">
                                {{ $t('Photo') }} <span class="text-muted">({{ $t('optional') }})</span>
                            </label>
                            <div class="col-sm-8">
                                <app-input type="custom-file-upload"
                                        :label="$t('upload_your_file')"
                                        v-model="photo"
                                        @change="setImageChange"/>
                                <small class="text-muted font-italic">
                                    {{ $t('recommended_custom_file_validation') }} - {{ $t('photo_optional_note') }}
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div class="row">
                            <!-- Phone Number Input -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="phone">{{ $t('phone') }} <span style="color: crimson">*</span></label>
                                    <app-input type="tel-input" v-model="inputs.phone" 
                                            placeholder="Enter phone number" :required="true"/>
                                </div>
                            </div>

                            <!-- Last Name Input -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="last_name">{{ $t('last_name') }} <span style="color: crimson">*</span></label>
                                    <app-input id="last_name" type="text" v-model="inputs.last_name"
                                        :placeholder="$t('last_name')" :required="true"/>
                                </div>
                            </div>
                            
                            <!-- Middle Name Input -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="middle_name">{{ $t('middle_name') }} <span style="color: crimson">*</span></label>
                                    <app-input id="middle_name" type="text" v-model="inputs.middle_name"
                                        :placeholder="$t('middle_name')" :required="true"/>
                                </div>
                            </div>
                            
                            <!-- First Name Input -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="first_name">{{ $t('first_name') }} <span style="color: crimson">*</span></label>
                                    <app-input id="first_name" type="text" v-model="inputs.first_name"
                                        :placeholder="$t('first_name')" :required="true"/>
                                </div>
                            </div>
                            

                            <!-- Email ID Name Input -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="email">{{ $t('email') }} <span style="color: crimson">*</span></label>
                                    <app-input id="email" type="text" v-model="inputs.email"
                                        :placeholder="$t('email')" :required="true"/>
                                </div>
                            </div>
                            
                            <!-- Additional Attributes -->
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="matricule">{{ $t('matricule') }} <span style="color: crimson">*</span></label>
                                    <app-input id="matricule" type="text" v-model="inputs.matricule" :placeholder="$t('matricule')" :required="true"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="gender">{{ $t('gender') }} 
                                        <span style="color: crimson">*</span>
                                        </label>
                                    <app-input class="w-100" id="gender" v-model="inputs.gender"
                                        :list="genderList" :placeholder="$t('choose_one')" type="search-select"
                                        :required="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="birth_date">{{ $t('birth_date') }} <span style="color: crimson">*</span></label>
                                    <app-input id="birth_date" type="date" v-model="inputs.birth_date" :placeholder="$t('birth_date')" :required="true"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="working_shift_id">{{ $t('working_shift') }}<span style="color: crimson">*</span></label>
                                    <app-input class="w-100" id="working_shift_id" v-model="inputs.working_shift_id" 
                                        :list="workingShiftList" list-value-field="name" :placeholder="$t('choose_one')" 
                                        type="search-select" :required="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="contract_type">{{ $t('contract_type') }} 
                                        <span style="color: crimson">*</span>
                                        </label>
                                    <app-input class="w-100" id="contract_type" v-model="inputs.contract_type"
                                        :list="contractTypeList" :placeholder="$t('choose_one')" type="search-select"
                                        :required="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="department_id">{{ $t('department') }} <span style="color: crimson">*</span></label>
                                    <app-input class="w-100" id="department_id" v-model="inputs.department_id" 
                                        :list="departmentList" list-value-field="name" :placeholder="$t('choose_one')" 
                                        type="search-select" :required="true"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="category_id">{{ $t('category') }} <span style="color: crimson">*</span></label>
                                    <app-input class="w-100" id="category_id" v-model="inputs.category_id" 
                                        :list="categoryList" list-value-field="name" :placeholder="$t('choose_one')" 
                                        type="search-select" :required="true"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="job_title_id">{{ $t('job_title') }} <span style="color: crimson">*</span></label>
                                    <app-input class="w-100" id="job_title_id" v-model="inputs.job_title_id" 
                                        :list="jobTitleList" list-value-field="name" :placeholder="$t('choose_one')" 
                                        type="search-select" :required="true"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="ssn">{{ $t('ssn') }}</label>
                                    <app-input id="ssn" type="text" v-model="inputs.ssn" :placeholder="$t('ssn')"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="start_date">{{ $t('start_date') }} <span style="color: crimson">*</span></label>
                                    <app-input id="start_date" type="date" v-model="inputs.start_date" :placeholder="$t('start_date')" :required="true"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="payroll_currency">{{ $t('payroll_currency') }} <span style="color: crimson">*</span></label>
                                    <app-input class="w-100" id="payroll_currency" v-model="inputs.payroll_currency"
                                        :list="payrollCurrencyList" :placeholder="$t('choose_one')" type="search-select"
                                        :required="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="contractual_salary">{{ `${$t('contractual_salary')} (${$t('optional')})` }}</label>
                                    <app-input id="contractual_salary" type="number" v-model="inputs.contractual_salary" 
                                                :placeholder="$t('contractual_salary')"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="base_salary">{{ $t('base_salary') }} ({{ inputs.payroll_currency }})<span style="color: crimson">*</span></label>
                                    <app-input id="base_salary" type="number" v-model="inputs.base_salary" 
                                                :placeholder="$t('base_salary')" :required="true"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="marital_status">{{ $t('marital_status') }} 
                                        <span style="color: crimson">*</span>
                                        </label>
                                    <app-input class="w-100" id="marital_status" v-model="inputs.marital_status"
                                        :list="maritalStatusList" :placeholder="$t('choose_one')" type="search-select"
                                        :required="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="dependents">{{ $t('dependents') }}</label>
                                    <app-input id="dependents" type="number" v-model="inputs.dependents" 
                                    :placeholder="$t('dependents')"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="children">{{ $t('children') }}</label>
                                    <app-input id="children" type="number" v-model="inputs.children" 
                                    :placeholder="$t('children')" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="leave_days">{{ $t('leave_days') }} <span style="color: crimson">*</span></label>
                                    <app-input id="leave_days" type="number" v-model="inputs.leave_days" 
                                               :placeholder="$t('leave_days')" :required="true"/>
                                </div>
                            </div>
                            <div class="col-md-6" style="display: none;">
                                <div class="form-group">
                                    <label for="extra_fees">{{ $t('extra_fees') }}</label>
                                    <app-input id="extra_fees" type="number" v-model="inputs.extra_fees" 
                                             :placeholder="$t('extra_fees')"/>
                                </div>
                            </div>
                            <div class="col-md-6" style="display: none;">
                                <div class="form-group">
                                    <label for="nationality">{{ $t('nationality') }}</label>
                                    <app-input id="nationality" type="text" v-model="inputs.nationality" :placeholder="$t('nationality')"/>
                                </div>
                            </div>
                            <div class="col-md-6" style="display: none;">
                                <div class="form-group">
                                    <label for="address">{{ $t('address') }}</label>
                                    <app-input id="address" type="text" v-model="inputs.address" :placeholder="$t('address')"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="status">{{ $t('status') }} 
                                        <span style="color: crimson">*</span>
                                        </label>
                                    <app-input class="w-100" id="status" v-model="inputs.status"
                                        :list="statusList" :placeholder="$t('choose_one')" type="search-select"
                                        :required="true" />
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="bank_id">{{ $t('bank') }}</label>
                                    <app-input class="w-100" id="bank_id" v-model="inputs.bank_id" 
                                        :list="bankList" list-value-field="name" :placeholder="$t('choose_one')" type="search-select"/>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="bank_account_number">{{ $t('bank_account_number') }}</label>
                                    <app-input id="bank_account_number" type="text" v-model="inputs.bank_account_number" 
                                        :placeholder="$t('bank_account_number')"/>
                                </div>
                            </div>

                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for="end_date">{{ $t('end_date') }}</label>
                                    <app-input id="end_date" type="date" 
                                                v-model="inputs.end_date" :placeholder="$t('end_date')"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </form>
        </template>
        <template slot="footer">
            <button type="button" class="btn btn-secondary mr-2" data-dismiss="modal" @click="closeModal">
                {{ $t('cancel') }}
            </button>
            <button type="button" class="btn btn-primary" @click="submit">{{ $t('save') }}</button>
        </template>
    </app-modal>
</template>

<script>
import axios from 'axios';
import { FormMixin } from '../../../../core/mixins/form/FormMixin';
import { ModalMixin } from '../../../Mixins/ModalMixin';
import { mapState } from 'vuex';
import { formatDateForServer } from '../../../../common/Helper/Support/DateTimeHelper';

export default {
    name: 'EmployeeAddEditModal',
    mixins: [FormMixin, ModalMixin],
    props: {
        tableId: {
            type: String,
        },
    },
    computed: {
        ...mapState({
            locationList: state => state.selects.locationList,
            workingShiftList: state => state.selects.workingShiftList,
            bankList: state => state.selects.bankList,
            departmentList: state => state.selects.departmentList,
            categoryList: state => state.selects.categoryList,
            jobTitleList: state => state.selects.jobTitleList,
        })
    },
    data() {
        return {
            preloader: false,
            modalId: 'employee-add-edit-modal',
            inputs: {
                payroll_currency: 'USD',
            },
            photo: {},
            isModalActive: false,
            modalTitle: `${this.$t('new-employee')}`,
            previewImage: null,
            imageChanged: false,
            statusList: [
                {
                    id: 'active',
                    value: this.$t('active')
                },
                {
                    id: 'suspended',
                    value: this.$t('suspended')
                },
                {
                    id: 'terminated',
                    value: this.$t('terminated')
                },
            ],
            genderList: [
                {
                    id: 'male',
                    value: this.$t('male')
                },
                {
                    id: 'female',
                    value: this.$t('female')
                }
            ],
            maritalStatusList: [
                {
                    id: 'single',
                    value: this.$t('single')
                },
                {
                    id: 'married',
                    value: this.$t('married')
                },
                {
                    id: 'divorced',
                    value: this.$t('divorced')
                },
                {
                    id: 'widowed',
                    value: this.$t('widowed')
                }
            ],
            contractTypeList: [
                {
                    id: 'permanent',
                    value: this.$t('permanent')
                },
                {
                    id: 'fixed-term',
                    value: this.$t('temporary')
                },
            ],
            payrollCurrencyList: [
                {
                    id: 'USD',
                    value: 'USD'
                },
                {
                    id: 'CDF',
                    value: 'CDF'
                },
            ],
        }
    },
    methods: {
        submit() {
            this.preloader = true;
            let url = this.selectedUrl ? `employees/${this.inputs.id}` : `employees`;
            let method = this.selectedUrl ? 'patch' : 'post';

            // For creation (POST), use FormData to handle optional photo upload
            if (method === 'post') {
                let formData = new FormData();
                
                // Add photo only if selected
                if (this.photo && this.photo instanceof File) {
                    formData.append("photo", this.photo);
                }
                
                formData.append("phone", this.inputs.phone);
                formData.append("first_name", this.inputs.first_name);
                formData.append("last_name", this.inputs.last_name);
                formData.append("middle_name", this.inputs.middle_name || '');
                formData.append("email", this.inputs.email || '');
                formData.append("assigned_location_id", this.inputs.assigned_location_id || '');
                formData.append("matricule", this.inputs.matricule || '');
                formData.append("gender", this.inputs.gender);
                formData.append("birth_date", formatDateForServer(this.inputs.birth_date)); 
                formData.append("ssn", this.inputs.ssn || '');
                formData.append("contract_type", this.inputs.contract_type);
                formData.append("start_date", formatDateForServer(this.inputs.start_date));
                formData.append("end_date", formatDateForServer(this.inputs.end_date) || '');
                formData.append("contractual_salary", this.inputs.contractual_salary || '');
                formData.append("base_salary", this.inputs.base_salary);
                formData.append("marital_status", this.inputs.marital_status);
                formData.append("dependents", this.inputs.dependents || 0);
                formData.append("children", this.inputs.children || 0);
                formData.append("leave_days", this.inputs.leave_days);
                formData.append("extra_fees", 1);
                formData.append("working_shift_id", this.inputs.working_shift_id);
                formData.append("nationality", this.inputs.nationality || '-');
                formData.append("address", this.inputs.address || '-');
                formData.append("status", this.inputs.status);
                formData.append("bank_account_number", this.inputs.bank_account_number || '');
                formData.append("bank_id", this.inputs.bank_id || '');
                formData.append("department_id", this.inputs.department_id);
                formData.append("category_id", this.inputs.category_id);
                formData.append("payroll_currency", this.inputs.payroll_currency);
                formData.append("job_title_id", this.inputs.job_title_id);

                axios({
                    method: method,
                    url: url,
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then(response => {
                    this.preloader = false;
                    this.$toastr.s(response.data.message);
                    this.$hub.$emit('reload-' + this.tableId);
                    this.closeModal();
                })
                .catch(error => {
                    this.preloader = false;
                    this.$toastr.e(error.response.data.message || 'An error occurred');
                });
            } else {
                // For update (PATCH), handle image conversion and JSON payload
                if (this.imageChanged && this.photo instanceof File) {
                    this.convertFileToBase64(this.photo).then(base64Photo => {
                        this.sendUpdateRequest(base64Photo);
                    }).catch(error => {
                        this.preloader = false;
                        this.$toastr.e('Failed to process image');
                    });
                } else {
                    this.sendUpdateRequest(null);
                }
            }
        },
        setImageChange($event) {
            this.imageChanged = true;
        },

        convertFileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result); // Base64 output
                reader.onerror = error => reject(error);
            });
        },

        sendUpdateRequest(base64Photo) {
            let payload = {
                phone: this.inputs.phone,
                first_name: this.inputs.first_name,
                last_name: this.inputs.last_name,
                middle_name: this.inputs.middle_name,
                email: this.inputs.email,
                employee_id: this.inputs.employee_id,
                assigned_location_id: this.inputs.assigned_location_id,
                job_title_id: this.inputs.job_title_id,
                matricule: this.inputs.matricule,
                gender: this.inputs.gender,
                birth_date: formatDateForServer(this.inputs.birth_date),
                ssn: this.inputs.ssn,
                contract_type: this.inputs.contract_type,
                start_date: formatDateForServer(this.inputs.start_date),
                end_date: formatDateForServer(this.inputs.end_date),
                contractual_salary: this.inputs.contractual_salary,
                base_salary: this.inputs.base_salary,
                marital_status: this.inputs.marital_status,
                dependents: this.inputs.dependents,
                children: this.inputs.children,
                leave_days: this.inputs.leave_days,
                extra_fees: this.inputs.extra_fees,
                working_shift_id: this.inputs.working_shift_id,
                nationality: this.inputs.nationality,
                address: this.inputs.address,
                status: this.inputs.status,
                bank_account_number: this.inputs.bank_account_number,
                bank_id: this.inputs.bank_id,
                department_id: this.inputs.department_id,
                category_id: this.inputs.category_id,
                payroll_currency: this.inputs.payroll_currency,
            };

            // Add photo to payload only if image was changed
            if (this.imageChanged && base64Photo) {
                payload.photo = base64Photo;
            }

            axios.patch(`employees/${this.inputs.id}`, payload, {
                headers: {
                    "Content-Type": "application/json"
                }
            })
            .then(response => {
                this.preloader = false;
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
                this.closeModal();
            })
            .catch(error => {
                this.preloader = false;
                let {message} = error.response.data;
                this.$toastr.e(message);
            });
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit('reload-' + this.tableId);
        },

        afterSuccessFromGetEditData(response) {
            this.inputs = response.data;
            this.photo = response.data.photo;
            this.inputs.birth_date = response.data.birth_date ? new Date(response.data.birth_date) : '';
            this.inputs.start_date = response.data.start_date ? new Date(response.data.start_date) : '';
            this.inputs.end_date = response.data.end_date ? new Date(response.data.end_date) : '';
            this.preloader = false;
        },
    },
    created() {
        this.$store.dispatch('getLocations');
        this.$store.dispatch('getWorkingShifts');
        this.$store.dispatch('getDepartments');
        this.$store.dispatch('getBanks');
        this.$store.dispatch('getCategories');
        this.$store.dispatch('getJobTitles');
        if (this.selectedUrl) {
            this.modalTitle = this.$t('edit');
            this.preloader = true;
        }
    },
}
</script>

<style>

</style>